import _sfc_main from './UiValue.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-ui-value", attrs: { "role": "presentation" } }, [_vm._t("root", function() {
    return [_vm._t("icon", function() {
      return [_vm.showIcon ? _c("span", { staticClass: "fds-ui-icon", class: _setup.iconClassModifier }) : _vm._e()];
    }, null, { iconClassModifier: _setup.iconClassModifier }), _vm._t("value", function() {
      return [_c("span", { class: ["fds-value", _setup.previousValueChangeCssClass, _setup.zeroChangeCssClass] }, [_setup.hasDisplayValue ? [_vm._v(_vm._s(_vm.displayValue))] : [_vm._v(_vm._s(_vm.value))]], 2)];
    }, null, { zeroChangeCssClass: _setup.zeroChangeCssClass, hasDisplayValue: _setup.hasDisplayValue }), _vm._t("unit", function() {
      return [_vm.unit ? _c("span", { staticClass: "fds-unit" }, [_vm._v(_vm._s(_vm.unit))]) : _vm._e()];
    }), _vm._t("badge", function() {
      return [_vm.priceQuality ? _c("span", { class: ["fds-ui-badge", "fds-ui-badge-quality", `fds-badge-quality-${_vm.priceQuality}`] }, [_vm._v(_vm._s(_setup.priceQualitySymbol))]) : _vm._e()];
    }, null, { priceQualitySymbol: _setup.priceQualitySymbol })];
  }, null, { iconClassModifier: _setup.iconClassModifier, zeroChangeCssClass: _setup.zeroChangeCssClass, hasDisplayValue: _setup.hasDisplayValue })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/ui-value/UiValue.vue";
var UiValue = __component__.exports;

export { UiValue as default };
